const VISUALIZATION_BOUNDARY_STYLE_ID = 'wavvest-visualization-boundary-styles';

const VISUALIZATION_BOUNDARY_STYLES = `<style id="${VISUALIZATION_BOUNDARY_STYLE_ID}">
  *, *::before, *::after {
    box-sizing: border-box;
  }

  html,
  body {
    max-width: 100%;
    overflow-x: auto;
  }

  .wrapper,
  .card,
  [data-segment] {
    max-width: 100%;
    min-width: 0;
  }

  .wrapper {
    width: 100%;
  }

  img,
  svg,
  video {
    max-width: 100%;
    height: auto;
  }

  canvas {
    max-width: 100%;
  }

  table {
    display: block;
    max-width: 100%;
    overflow-x: auto;
  }

  [class*="grid"],
  [style*="display: grid"],
  [style*="display:grid"],
  [style*="display: flex"],
  [style*="display:flex"] {
    max-width: 100%;
    min-width: 0;
  }

  [class*="grid"] > *,
  [style*="display: grid"] > *,
  [style*="display:grid"] > *,
  [style*="display: flex"] > *,
  [style*="display:flex"] > * {
    max-width: 100%;
    min-width: 0;
  }
</style>`;

export function withVisualizationBoundaryStyles(sourceCode: string): string {
  if (!sourceCode || sourceCode.includes(`id="${VISUALIZATION_BOUNDARY_STYLE_ID}"`)) {
    return sourceCode;
  }

  if (/<\/head>/i.test(sourceCode)) {
    return sourceCode.replace(/<\/head>/i, `${VISUALIZATION_BOUNDARY_STYLES}\n</head>`);
  }

  if (/^<!doctype[^>]*>/i.test(sourceCode)) {
    return sourceCode.replace(
      /^<!doctype[^>]*>/i,
      (doctype) => `${doctype}\n${VISUALIZATION_BOUNDARY_STYLES}`,
    );
  }

  return `${VISUALIZATION_BOUNDARY_STYLES}\n${sourceCode}`;
}
